import { ChainId } from '@ourzora/chains'
import {
  UNIVERSAL_ROUTER_ADDRESS,
  UniversalRouterVersion,
} from '@uniswap/universal-router-sdk'
import {
  arbitrum,
  base,
  baseSepolia,
  mainnet,
  optimism,
  sepolia,
  zora,
} from 'viem/chains'
import { cleanAddress, LowercaseAddress } from '../../addresses'
import { abi } from './abi'

export const UniswapUniversalRouter = {
  abi,
  address: {
    [base.id]: cleanAddress(
      UNIVERSAL_ROUTER_ADDRESS(UniversalRouterVersion.V2_0, base.id)
    ),
    [baseSepolia.id]: cleanAddress(
      UNIVERSAL_ROUTER_ADDRESS(UniversalRouterVersion.V2_0, baseSepolia.id)
    ),
    [mainnet.id]: cleanAddress(
      UNIVERSAL_ROUTER_ADDRESS(UniversalRouterVersion.V2_0, mainnet.id)
    ),
    [optimism.id]: cleanAddress(
      UNIVERSAL_ROUTER_ADDRESS(UniversalRouterVersion.V2_0, optimism.id)
    ),
    [arbitrum.id]: cleanAddress(
      UNIVERSAL_ROUTER_ADDRESS(UniversalRouterVersion.V2_0, arbitrum.id)
    ),
    [zora.id]: cleanAddress(
      UNIVERSAL_ROUTER_ADDRESS(UniversalRouterVersion.V2_0, zora.id)
    ),
    [sepolia.id]: cleanAddress(
      UNIVERSAL_ROUTER_ADDRESS(UniversalRouterVersion.V2_0, sepolia.id)
    ),
  } satisfies Partial<Record<ChainId, LowercaseAddress>>,
} as const
